import ReactApexChart from "react-apexcharts";
import Select from "react-select";
import conversion from "../../../images/conversion_rate.png";
import { MONTHS_ARRAY, MONTHS_FOR_DATA_ARRAY } from "../helper";
import { useMemo } from "react";
import { hiredStatusChecks } from "../../../constants/statusConsts";

const HiringPerformance = ({
  departments,
  hiringManagers,
  performanceData = { hired: [], offered: [] },
  userPrivilege
}) => {
  const hireOfferData = useMemo(() => {
    // Helper to convert array of {month, count} to map
    const listToMap = (list) => {
        const map = {};
        if (list) {
            list.forEach(item => {
                map[item.month] = item.count;
            });
        }
        return map;
    };

    const hiredMap = listToMap(performanceData.hired);
    const offeredMap = listToMap(performanceData.offered);

    const hireDataArray = MONTHS_FOR_DATA_ARRAY.map(
      (month) => hiredMap[month] || 0
    );
    const offerDataArray = MONTHS_FOR_DATA_ARRAY.map(
      (month) => (offeredMap[month] || 0) + (hiredMap[month] || 0)
    );

    return {
      hiredData: hireDataArray,
      offerData: offerDataArray,
    };
  }, [performanceData]);

  const mixedChart = {
    series: [
      {
        name: "Hire",
        data: hireOfferData.hiredData,
        type: "area",
      },
      {
        name: "Offer",
        data: hireOfferData.offerData,
        type: "line",
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "line",
        dropShadow: {
          enabled: false,
        },
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      colors: ["#4064C5", "#CB4728"],
      stroke: {
        curve: "smooth",
        width: 2,
      },
      fill: {
        type: "solid",
        opacity: [0.3, 1],
      },
      dataLabels: {
        enabled: true,
        background: {
          enabled: false,
        },
        offsetY: -5,
        formatter: (val) => Math.round(val),
      },
      yaxis: {
        labels: {
          formatter: (val) => Math.round(val),
        },
      },
      tooltip: {
        y: {
          formatter: (val) => Math.round(val),
        },
      },

      legend: {
        show: true,
        itemMargin: {
          horizontal: 10,
        },
      },
      grid: {
        show: true,
      },
      xaxis: {
        categories: MONTHS_ARRAY,
      },
    },
  };
  return (
   <div className="bg-white pb-7 py-3 items-center rounded-divRadius shadow-sh">
  <div className="flex items-center justify-between w-full">
    <h2 className="font-semibold relative text-[16px] pl-4 leading-[18.75px] before:block before:bg-blue-500 before:w-1 before:content-'' before:absolute before:left-0 before:top-1/2 before:h-2/4 before:mr-4 before:transform before:-translate-y-1/2">
      Hiring Performance
    </h2>
    <div className="flex invisible justify-end space-x-3 pr-4">
      <Select className="text-sm" options={departments}></Select>
      <Select className="text-sm" options={hiringManagers}></Select>
    </div>
  </div>
  <div className="bg-gray-300 h-[1px] mt-3 w-full"></div>
  <div className="px-4 h-[20rem]">
    {userPrivilege === "Hiring Manager" ? (
      <div className="flex h-[20rem] justify-center w-full items-center">
        <div>
          <img className="h-28 mx-auto" src={conversion} alt="" />
          <p className="text-center text-sm mt-2 font-semibold">
            No data to display.
          </p>
        </div>
      </div>
    ) : hireOfferData.offerData.length > 0 &&
      hireOfferData.hiredData.length > 0 ? (
      <ReactApexChart
        options={mixedChart.options}
        series={mixedChart.series}
        type="line"
        height={320}
      />
    ) : (
      <div className="flex h-[20rem] justify-center w-full items-center">
        <div>
          <img className="h-28 mx-auto" src={conversion} alt="" />
          <p className="text-center text-sm mt-2 font-semibold">
            Hiring performance metrics will show up as you make your next hires.
          </p>
        </div>
      </div>
    )}
  </div>
</div>

  );
};

export default HiringPerformance;
